/**
 * The sentence the BACKEND wanted the operator to read, out of an axios error.
 *
 * NestJS `HttpException`s put the human sentence in `data.message` — a string,
 * or an array of them for class-validator failures. `data.error` is only the
 * status name ("Conflict", "Bad Request"), and the `SentryExceptionFilter` this
 * API runs strips it from the body entirely, so a handler that reads `error`
 * first shows a generic failure for every refusal the server took the trouble
 * to word (PRX-56 R18: the courier contradiction 400, the no-default 400 and
 * the unknown-courier 404 all rendered as "Failed to change delivery type").
 *
 * `fallback` is used only when the response carries no sentence at all — a
 * network failure, or a 500 whose detail must not reach the client anyway.
 */
export function apiErrorMessage(error: any, fallback: string): string {
  const raw = error?.response?.data?.message;
  const message = Array.isArray(raw) ? raw.filter(Boolean).join('; ') : raw;
  return message || error?.response?.data?.error || fallback;
}
